<template>
  <div class="row justify-content-md-center m-0 p-0">
    <div class="col-12 p-0 m-0" v-if="rol == 1">
      <div class="col-12 mt-0" v-if="showForm">
        <v-card class="mx-auto" outlined>

          <v-card-title>
            Agregar tipo declaración
          </v-card-title>
          <v-card-text>
            <div class="row d-flex align-items-end">
              <div class="col-md-4 col-lg-4 col-sm-12 ">
                <label class="control-label">
                  Tipo declaración
                </label>
                <el-select class="select-default" filterable name="tipo_dec" placeholder="Tipo declaración" v-model="formItem.tipo_dec">
                  <el-option v-for="option in tipo_declaracion" class="select-default" :value="option.id" :label="option.valor" :key="option.id+'tipo'">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-lg-4 col-sm-12">
                <label class="control-label">
                  Periodo
                </label>
                <el-select class="select-default" filterable name="periodo" placeholder="Periodo" v-model="formItem.periodo">
                  <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-4 col-lg-4 col-sm-12">
                <label class="control-label">

                </label>
                <button class="btn btn-primary mr-2" @click.prevent="save()">
                  <span> <i class="fas fa-save"></i> Guardar </span>
                </button>
                <button class="btn btn-danger" @click.prevent="showForm = false">
                  <span> <i class="fa fa-times"></i> Cancelar </span>
                </button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="col-12 mt-0" v-else>
        <button class="btn btn-primary" @click.prevent="addItem()">
          <span> <i class="fa fa-plus"></i> Agregar </span>
        </button>
      </div>
    </div>
    <div class="col-12  pt-0 mt-0 d-flex justify-content-center">
      <v-data-table :headers="headers" :items="utdeclaraciones" :items-per-page="5" class="my-table" :fixed-header="true">
        <template v-slot:item.acciones="{ item }">
          <div class="d-flex justify-content-center">
            <b-button @click.prevent="remove(item)" class="btn-s edit mr-2" variant="danger" v-if="rol == 1" :disabled="item.declaracion_id != null">
              <i class="fas fa-trash"></i></b-button>
            <br>
          </div>
        </template>
        <template v-slot:item.pendiente="{ item }">
          <div class="alert  mb-0 p-1" :class="(item.declaracion_id)?'alert-info':'alert-warning'">
            <b> {{(item.declaracion_id)?'Realizada':'Pendiente'}}</b>
          </div>
        </template>

        <template v-slot:item.fecha_posesion="{ item }">
          <div>
            {{dateFormat(item.fecha_posesion)}}
          </div>
        </template>
        <template v-slot:item.fecha_termino="{ item }">
          <div>
            {{dateFormat(item.fecha_termino)}}
          </div>
        </template>
        <template v-slot:item.fecha_declaracion="{ item }">
          <div>
            {{dateFormat(item.fecha_declaracion)}}
          </div>
        </template>
        <template v-slot:item.tipo_dec_id="{ item }">
          <div>
            <b> {{tipoDecCat(item.tipo_dec_id)}}</b>
          </div>
        </template>

      </v-data-table>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  export default {
    props: {
      data: {
        type: Object,
        default: () => {}
      },
    },
    // props: ["data"],
    data() {
      return {
        showForm: false,
        rol: null,
        formItem: {
          periodo: new Date().getFullYear(),
          tipo_dec: 1
        },
        utdeclaraciones: [],
        periodos: [],
        tipo_declaracion: [{
          'id': 1,
          'valor': 'Inicial',
        }, {
          'id': 2,
          'valor': 'Anual',
        }, {
          'id': 3,
          'valor': 'Final'
        }],
        headers: [
          // {
          //   text: 'Acciones',
          //   align: 'center',
          //   sortable: false,
          //   value: 'acciones',
          //   class: ''
          // },
          {
            text: 'Pendiente',
            value: 'pendiente',
            align: 'center',
          },
          {
            text: 'Tipo declaración',
            value: 'tipo_dec_id',
            align: 'center',
          },
          {
            text: 'Periodo',
            value: 'periodo',
            align: 'center',
          },
          {
            text: 'Dependencia',
            value: 'ente',
            align: 'center',
          },
          {
            text: 'Fecha posesión',
            value: 'fecha_posesion',
            align: 'center',
          },
          {
            text: 'Fecha término',
            value: 'fecha_termino',
            align: 'center',
          },
          {
            text: 'Fecha declaración',
            value: 'fecha_declaracion',
            align: 'center',
          },

        ],
      };
    },
    methods: {
      dateFormat: function (date) {
        if (date) {
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        }
        return '';
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            var anios = response.data.periodos;

            anios.forEach(y => {
              if (y.year) {
                this.periodos.push(y);
              }
            });
            this.formItem.periodo = this.periodos[0].year;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      tipoDecCat(tipo) {
        var t = '';
        switch (tipo) {
          case 1:
            t = 'Inicial';
            break;
          case 2:
            t = 'Anual';
            break;
          case 3:
            t = 'Final';
            break;

        }
        return t;
      },
      save() {
        // this.showForm = false;
        this.formItem.ip_id = this.data.id;

        this.$http.post('tipo_dec_agregar', this.formItem).then(response => {
            //
            this.utdeclaraciones.push(response.data.tipo_dec);
            this.showForm = false;
          },
          error => {
            this.Err(error);
          }
        );

      },
      addItem() {
        this.showForm = true;
      },
      edit() {

      },
      remove(item) {

        this.Ask("Desea borrar este registro", () => {
          this.$http.delete('tipo_dec_delete/' + item.id).then(response => {
              let index = this.utdeclaraciones.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.utdeclaraciones.splice(index, 1);
            },
            error => {
              this.Err(error);
            }
          );
        });
      },
    },
    created() {
      this.rol = this.getKey('role');

      if (this.rol == 1) {
        this.headers.unshift({
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        });
      }
      this.getPeriodos();
      if (this.data) {
        this.utdeclaraciones = this.data.utdeclaraciones;
      }
    },
  };

</script>
<style>
  .btn:disabled {
    color: #d6d6d6;
  }

  .v-data-table.my-table.v-data-table--fixed-header.v-data-table--has-bottom.theme--light {
    margin: 0 auto;
    width: 98% !important;
    max-width: 98% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/TipoDec.component.vue